export enum RiskStatus {
  ACTIVE = 'active',
  ACCEPTED = 'accepted',
  REMEDIATED = 'remediated',
}
